<template>
  <div class="content">
    <div class="balance">
      <span>余额：</span>
      <img src="../../../assets/mine/jb.png" alt="" />
      <span class="num">{{ price || 0 }}</span>
    </div>

    <div class="title">
      <div class="title-line"></div>
      <div class="title-txt">请选择充值额度</div>
      <div class="title-r-t">1元=10金币</div>
    </div>
    <div class="cz-xx">
      <div
        :class="{ action: index == current }"
        v-for="(item, index) in list"
        :key="index"
        @click="current = index"
      >
        <p class="jb-num">{{ item.gold }}金币</p>
        <p class="zs-num">赠送{{ item.give }}金币</p>
        <p class="price">￥{{ item.money }}</p>
      </div>
    </div>

    <div class="balance">
      <span>充值额度：</span>
      <span class="num" style="color: #f9647d"
        >{{ (list.length && list[current].money) || "" }}元</span
      >
    </div>
    <div class="ps">
      <p>温馨提示：</p>
      <p>
        1.充值前请确保您的网络通畅，充值过程如遇到问题，请咨询客服
      </p>
      <p>2.金币充值后无法进行退款。</p>
      <p>3.金币使用后如有退款情况发生，退还到个人账户中。</p>
      <p>4.其他充值活动详细请关注可以测公众号，感谢您对可以测的支持</p>
    </div>

    <div class="button" @click="goldRecharge">确认充值</div>
  </div>
</template>

<script>
/**
@description:充值金币
@createTime:2021-08-26
@create:wq
*/
import wx from "jweixin-module";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      current: 0,
      list: [],
      price: JSON.parse(localStorage.getItem("user")).gold,
      payParams:{},
      href: "http://h5.keyice.club/alipay/",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.goldRechargeList();
    this.jsSdk();
  },
  methods: {
    goldRechargeList() {
      this.api.goldRechargeList().then((res) => {
        this.list = res.data;
      });
    },
    goldRecharge() {
      console.log(this.list[this.current]);
      let id = this.list[this.current].id;
      this.Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.api.order({ type: 4, id: id }).then((res) => {
        console.log(res);
        let order_sn = res.data.order_sn;
        this.href = this.href + order_sn;
        this.Toast.clear();
        window.location.href = this.href;
        // if(res.data.order_sn){ //微信支付
        //   this.pay(res.data)
        // }
      });
    },
    pay(data){
      let id = data.id
      const that = this;
      this.api.pay({ id }).then((res) => {
        this.payParams = res;
        // 微信支付
        wx.chooseWXPay({
          timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
          package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: res.data.paySign, // 支付签名
          success: function () {
            setTimeout(() => {
              if (that.type == 1) {
                that.$router.replace('orderzx');
              } else if (that.type == 2) {
                that.$router.replace('orderaw');
              } else if (that.type == 3) {
                that.$router.replace('kcOrder');
              }
              that.price += (that.list[that.current].gold + that.list[that.current].give);

            }, 2000);
            // 支付成功后的回调函数
          },
        });
      });
    },
    jsSdk() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let url = "";
      if (isiOS) {
        url = window.location.href.split("#")[0];
      } else {
        url = window.location.href;
      }
      this.api.jsSdk({ url }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          console.log("===========");
          wx.error((res) => {
            console.log(res);
          });
          // TODO
        });
      });
    },
  },
  // 在创建之前，添加body的style属性， 单独设置背景色
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#F5F5F5");
  },

  // 在销毁前，将body的style属性删除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
  overflow: hidden;
}
.balance {
  margin: 0.22rem 0;

  height: 0.8rem;
  background: #ffffff;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  padding: 0 0.38rem;

  font-size: 0.3rem;
  font-weight: 400;
  color: #333333;
  img {
    width: 0.38rem;
    margin-right: 0.16rem;
  }
  .num {
    color: #f3b953;
  }
}
.title {
  display: flex;
  align-items: center;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.16rem;
  }
  .title-txt {
    flex: 1;

    font-size: 0.32rem;
    font-weight: 400;
    color: #666666;
  }
  .title-r-t {
    font-size: 0.28rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #f3ba55;
  }
}
.cz-xx {
  margin-top: 0.22rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  > div {
    width: 3.46rem;
    height: 2rem;
    background: #ffffff;
    border-radius: 0.2rem;
    padding: 0.14rem 0.16rem 0.12rem 0.24rem;
    box-sizing: border-box;
    margin-bottom: 0.1rem;
    overflow: hidden;
  }
  .jb-num {
    font-size: 0.4rem;
    font-weight: 400;
    color: #f3ba55;
  }
  .zs-num {
    font-size: 0.24rem;
    font-weight: 400;
    color: #f3ba55;
    margin-top: 0.12rem;
  }
  .price {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    text-align: right;
    margin-top: 0.3rem;
  }
  .action {
    position: relative;
    border: 1px solid #53cedc;
    &::before {
      content: "";
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      width: 1rem;
      height: 1rem;
      background: #53cedc;
      transform: rotate(45deg);
    }
    &::after {
      content: "\e601";
      position: absolute;
      top: 0.08rem;
      right: 0.08rem;
      color: white;
      font-family: "iconfont" !important;
      font-size: 0.26rem;
      font-style: normal;
    }
  }
}
.ps {
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
  // p:last-child {
  //   margin-top: 0.4rem;
  // }
}
.button {
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.25rem;
}
</style>
